module.exports = __webpack_public_path__ + "static/media/o_grande_desafio_total.6d4e4cf2.jpg";